import { createContext } from 'react';

export const IsMobileContext = createContext({ isMobile: false });
